import React from 'react'

const Popup = () => {
    return (
        <div className="popup">
            <div className="popup_wrap">
                <img className="popup_close" src="/events/img/btn_close.png" alt="關閉彈跳視窗"/>
                {/* <!--注意事項--> */}
                <div className="event_notice">
                    <img src="/events/img/notice_word.png" alt=""/>
                </div>
                {/* <!--參加辦法--> */}
                <div className="event_howto">
                    <img src="/events/img/tip_word.png" alt=""/>
                </div>
                {/* <!--影片--> */}
                <div className="pop_video">
                    <div className="live_video-container">
                        <iframe className="youtube-video" width="560" height="315" src="" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                </div>
               
            
                
            </div>
        </div>
    )
}

export default Popup
